export default "https://api.sistemagerenciador.app.br";
